<template>
  <router-view />
</template>

<script setup lang="ts">
// 管理后台根组件
</script>
